import React from 'react';
import { useStyles } from '../../Assessment/RGZButtons.styles';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import CheckIcon from '@mui/icons-material/Check';

interface AssignAdnotationsButtonProps {
  onClick: () => void;
}

const AssignAdnotationsButton: React.FC<AssignAdnotationsButtonProps> = (props) => {
  const classes = useStyles();

  return (
    <TooltipOne title="Przypisz adnotacje" placement="top">
      <div>
        <ButtonOne
          color="inherit"
          variant="contained"
          className={classes.activeButton}
          style={{ backgroundColor: '#FFFFFF', color: '#3560FF', border: 'solid 1px #3560FF' }}
          startIcon={<CheckIcon />}
          onClick={() => props.onClick()}
        >
          Przypisz adnotacje
        </ButtonOne>
      </div>
    </TooltipOne>
  );
};

export default AssignAdnotationsButton;
